import { MsalProvider } from '@azure/msal-react';
import { Navigate, Route, Routes } from 'react-router-dom';
import packageJson from '../package.json';
import { msalInstance } from './auth/msal';
import { ProtectedRoute } from './components';
import { Header } from './components/Header';
import {
  History,
  RunCreator,
  RunDetail,
  RunList,
  SharedLinkJoin,
} from './pages';

// Coffee Run App Component - Original Implementation
function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <div className="min-h-screen bg-gray-50">
        <Header />

        <main className="container mx-auto px-4 py-8">
          <Routes>
            <Route path="/" element={<RunList />} />
            <Route path="/join/:shareCode" element={<SharedLinkJoin />} />
            <Route
              path="/run/new"
              element={
                <ProtectedRoute>
                  <RunCreator />
                </ProtectedRoute>
              }
            />
            <Route
              path="/run/:id"
              element={
                <ProtectedRoute>
                  <RunDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/history"
              element={
                <ProtectedRoute>
                  <History />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>

        <footer className="bg-white border-t border-gray-200 mt-12">
          <div className="container mx-auto px-4 py-6">
            <div className="text-center text-sm text-gray-600">
              <p>☕ Coffee Run - Streamlining group orders since 2025</p>
              <p className="mt-1">Made with ❤️ for better coffee experiences</p>
              <p className="mt-2 text-xs text-gray-500">
                Version {packageJson.version}
              </p>
            </div>
          </div>
        </footer>
      </div>
    </MsalProvider>
  );
}

export default App;
